/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ExamineList',
  components: {},
  props: {},
  data: function data() {
    return {
      examineList: [{
        personName: '',
        time: '',
        personid: '00011',
        state: '待审核'
      }, {
        personName: '',
        time: '',
        personid: '00012',
        state: '待审核'
      }]
    };
  },
  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    inductionDetails: function inductionDetails() {
      this.$router.push({
        path: '/InductionDetails' // query: {
        //     personid: item.personid,
        // },

      });
    }
  }
};